<div class="page-title mb-4">
    {{'dashboard.title' | translate}}
</div>

<div *ngIf="TEMP_UNTIL_OTHER_TABS"
    class="d-flex align-items-center justify-content-center flex-wrap gap-4 my-2"
>
    <button class="btn switch-btn" [ngClass]="{'switch-btn-active': viewMode === 0}" [disabled]="viewMode === 0" (click)="switchHandler('Contract')">
        <i class="app-icon icon icon-contract-1 icon-xxxl"></i>
        <span>
            {{'dashboard.contracts' | translate}}
        </span>
    </button>

    <button class="btn switch-btn" [ngClass]="{'switch-btn-active': viewMode === 1}" [disabled]="viewMode === 1" (click)="switchHandler('Asset')">
        <i class="app-icon icon icon-car icon-xxxl"></i>
        <span>
            {{'dashboard.asset' | translate}}
        </span>
    </button>

    <button class="btn switch-btn" [ngClass]="{'switch-btn-active': viewMode === 2}" [disabled]="viewMode === 2" (click)="switchHandler('Request')">
        <i class="app-icon icon icon-envelope-open icon-xxxl"></i>
        <span>
            {{'dashboard.request' | translate}}
        </span>
    </button>
</div>

<dashboard-contract *ngIf="viewMode === 0"></dashboard-contract>

